import '../helper/global-jquery';

$('.vd-filter-container.status.status--closed').each(function () {
  const container = $(this);
  const filterToggle = $(this).find('[data-action="show-filter"]');

  container.on('click', '[data-action="show-filter"]', function () {
    $(this).remove();
    container.removeClass('status--closed').addClass('status--open');
  });
});
